/* tslint:disable */
/* eslint-disable */
/**
 * Real Estate CRM Web API
 * API endpoints for web application
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AssignUnitToFloorCommand } from '../models';
// @ts-ignore
import { CreateUnitCommand } from '../models';
// @ts-ignore
import { UnitAttachmentDto } from '../models';
// @ts-ignore
import { UnitBasicInfoDto } from '../models';
// @ts-ignore
import { UnitCategoryFloorDto } from '../models';
// @ts-ignore
import { UnitDealHistoryDto } from '../models';
// @ts-ignore
import { UnitDtoPaginatedList } from '../models';
// @ts-ignore
import { UnitStatisticsDto } from '../models';
// @ts-ignore
import { UpdateUnitCommand } from '../models';
// @ts-ignore
import { UpdateUnitStockCommand } from '../models';
/**
 * UnitsApi - axios parameter creator
 * @export
 */
export const UnitsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {number} [categoryId] 
         * @param {number} [projectId] 
         * @param {string} [searchTerm] 
         * @param {boolean} [isActive] 
         * @param {boolean} [hasStock] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsGet: async (pageNumber?: number, pageSize?: number, categoryId?: number, projectId?: number, searchTerm?: string, isActive?: boolean, hasStock?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Units`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['CategoryId'] = categoryId;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['ProjectId'] = projectId;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['SearchTerm'] = searchTerm;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['IsActive'] = isActive;
            }

            if (hasStock !== undefined) {
                localVarQueryParameter['HasStock'] = hasStock;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {AssignUnitToFloorCommand} [assignUnitToFloorCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsIdAssignFloorPost: async (id: number, assignUnitToFloorCommand?: AssignUnitToFloorCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUnitsIdAssignFloorPost', 'id', id)
            const localVarPath = `/api/Units/{id}/assign-floor`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignUnitToFloorCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsIdAttachmentsAttachmentIdDelete: async (id: number, attachmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUnitsIdAttachmentsAttachmentIdDelete', 'id', id)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('apiUnitsIdAttachmentsAttachmentIdDelete', 'attachmentId', attachmentId)
            const localVarPath = `/api/Units/{id}/attachments/{attachmentId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsIdAttachmentsAttachmentIdGet: async (id: number, attachmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUnitsIdAttachmentsAttachmentIdGet', 'id', id)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('apiUnitsIdAttachmentsAttachmentIdGet', 'attachmentId', attachmentId)
            const localVarPath = `/api/Units/{id}/attachments/{attachmentId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsIdAttachmentsGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUnitsIdAttachmentsGet', 'id', id)
            const localVarPath = `/api/Units/{id}/attachments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [unitId] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsIdAttachmentsPost: async (id: number, unitId?: number, file?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUnitsIdAttachmentsPost', 'id', id)
            const localVarPath = `/api/Units/{id}/attachments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (unitId !== undefined) { 
                localVarFormParams.append('UnitId', unitId as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsIdDealsGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUnitsIdDealsGet', 'id', id)
            const localVarPath = `/api/Units/{id}/deals`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUnitsIdDelete', 'id', id)
            const localVarPath = `/api/Units/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsIdFloorsGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUnitsIdFloorsGet', 'id', id)
            const localVarPath = `/api/Units/{id}/floors`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUnitsIdGet', 'id', id)
            const localVarPath = `/api/Units/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateUnitCommand} [updateUnitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsIdPut: async (id: number, updateUnitCommand?: UpdateUnitCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUnitsIdPut', 'id', id)
            const localVarPath = `/api/Units/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUnitCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsIdStatisticsGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUnitsIdStatisticsGet', 'id', id)
            const localVarPath = `/api/Units/{id}/statistics`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateUnitStockCommand} [updateUnitStockCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsIdStockPut: async (id: number, updateUnitStockCommand?: UpdateUnitStockCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUnitsIdStockPut', 'id', id)
            const localVarPath = `/api/Units/{id}/stock`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUnitStockCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateUnitCommand} [createUnitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsPost: async (createUnitCommand?: CreateUnitCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Units`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUnitCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UnitsApi - functional programming interface
 * @export
 */
export const UnitsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UnitsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {number} [categoryId] 
         * @param {number} [projectId] 
         * @param {string} [searchTerm] 
         * @param {boolean} [isActive] 
         * @param {boolean} [hasStock] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitsGet(pageNumber?: number, pageSize?: number, categoryId?: number, projectId?: number, searchTerm?: string, isActive?: boolean, hasStock?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitDtoPaginatedList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitsGet(pageNumber, pageSize, categoryId, projectId, searchTerm, isActive, hasStock, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {AssignUnitToFloorCommand} [assignUnitToFloorCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitsIdAssignFloorPost(id: number, assignUnitToFloorCommand?: AssignUnitToFloorCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitsIdAssignFloorPost(id, assignUnitToFloorCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitsIdAttachmentsAttachmentIdDelete(id: number, attachmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitsIdAttachmentsAttachmentIdDelete(id, attachmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitsIdAttachmentsAttachmentIdGet(id: number, attachmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitsIdAttachmentsAttachmentIdGet(id, attachmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitsIdAttachmentsGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UnitAttachmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitsIdAttachmentsGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [unitId] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitsIdAttachmentsPost(id: number, unitId?: number, file?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitsIdAttachmentsPost(id, unitId, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitsIdDealsGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UnitDealHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitsIdDealsGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitsIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitsIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitsIdFloorsGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UnitCategoryFloorDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitsIdFloorsGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitsIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitBasicInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateUnitCommand} [updateUnitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitsIdPut(id: number, updateUnitCommand?: UpdateUnitCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitsIdPut(id, updateUnitCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitsIdStatisticsGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitStatisticsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitsIdStatisticsGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateUnitStockCommand} [updateUnitStockCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitsIdStockPut(id: number, updateUnitStockCommand?: UpdateUnitStockCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitsIdStockPut(id, updateUnitStockCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateUnitCommand} [createUnitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitsPost(createUnitCommand?: CreateUnitCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitsPost(createUnitCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UnitsApi - factory interface
 * @export
 */
export const UnitsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UnitsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {number} [categoryId] 
         * @param {number} [projectId] 
         * @param {string} [searchTerm] 
         * @param {boolean} [isActive] 
         * @param {boolean} [hasStock] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsGet(pageNumber?: number, pageSize?: number, categoryId?: number, projectId?: number, searchTerm?: string, isActive?: boolean, hasStock?: boolean, options?: any): AxiosPromise<UnitDtoPaginatedList> {
            return localVarFp.apiUnitsGet(pageNumber, pageSize, categoryId, projectId, searchTerm, isActive, hasStock, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {AssignUnitToFloorCommand} [assignUnitToFloorCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsIdAssignFloorPost(id: number, assignUnitToFloorCommand?: AssignUnitToFloorCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiUnitsIdAssignFloorPost(id, assignUnitToFloorCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsIdAttachmentsAttachmentIdDelete(id: number, attachmentId: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiUnitsIdAttachmentsAttachmentIdDelete(id, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsIdAttachmentsAttachmentIdGet(id: number, attachmentId: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiUnitsIdAttachmentsAttachmentIdGet(id, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsIdAttachmentsGet(id: number, options?: any): AxiosPromise<Array<UnitAttachmentDto>> {
            return localVarFp.apiUnitsIdAttachmentsGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [unitId] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsIdAttachmentsPost(id: number, unitId?: number, file?: File, options?: any): AxiosPromise<string> {
            return localVarFp.apiUnitsIdAttachmentsPost(id, unitId, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsIdDealsGet(id: number, options?: any): AxiosPromise<Array<UnitDealHistoryDto>> {
            return localVarFp.apiUnitsIdDealsGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiUnitsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsIdFloorsGet(id: number, options?: any): AxiosPromise<Array<UnitCategoryFloorDto>> {
            return localVarFp.apiUnitsIdFloorsGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsIdGet(id: number, options?: any): AxiosPromise<UnitBasicInfoDto> {
            return localVarFp.apiUnitsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateUnitCommand} [updateUnitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsIdPut(id: number, updateUnitCommand?: UpdateUnitCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiUnitsIdPut(id, updateUnitCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsIdStatisticsGet(id: number, options?: any): AxiosPromise<UnitStatisticsDto> {
            return localVarFp.apiUnitsIdStatisticsGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateUnitStockCommand} [updateUnitStockCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsIdStockPut(id: number, updateUnitStockCommand?: UpdateUnitStockCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiUnitsIdStockPut(id, updateUnitStockCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateUnitCommand} [createUnitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitsPost(createUnitCommand?: CreateUnitCommand, options?: any): AxiosPromise<number> {
            return localVarFp.apiUnitsPost(createUnitCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiUnitsGet operation in UnitsApi.
 * @export
 * @interface UnitsApiApiUnitsGetRequest
 */
export interface UnitsApiApiUnitsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UnitsApiApiUnitsGet
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {number}
     * @memberof UnitsApiApiUnitsGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {number}
     * @memberof UnitsApiApiUnitsGet
     */
    readonly categoryId?: number

    /**
     * 
     * @type {number}
     * @memberof UnitsApiApiUnitsGet
     */
    readonly projectId?: number

    /**
     * 
     * @type {string}
     * @memberof UnitsApiApiUnitsGet
     */
    readonly searchTerm?: string

    /**
     * 
     * @type {boolean}
     * @memberof UnitsApiApiUnitsGet
     */
    readonly isActive?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof UnitsApiApiUnitsGet
     */
    readonly hasStock?: boolean
}

/**
 * Request parameters for apiUnitsIdAssignFloorPost operation in UnitsApi.
 * @export
 * @interface UnitsApiApiUnitsIdAssignFloorPostRequest
 */
export interface UnitsApiApiUnitsIdAssignFloorPostRequest {
    /**
     * 
     * @type {number}
     * @memberof UnitsApiApiUnitsIdAssignFloorPost
     */
    readonly id: number

    /**
     * 
     * @type {AssignUnitToFloorCommand}
     * @memberof UnitsApiApiUnitsIdAssignFloorPost
     */
    readonly assignUnitToFloorCommand?: AssignUnitToFloorCommand
}

/**
 * Request parameters for apiUnitsIdAttachmentsAttachmentIdDelete operation in UnitsApi.
 * @export
 * @interface UnitsApiApiUnitsIdAttachmentsAttachmentIdDeleteRequest
 */
export interface UnitsApiApiUnitsIdAttachmentsAttachmentIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof UnitsApiApiUnitsIdAttachmentsAttachmentIdDelete
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof UnitsApiApiUnitsIdAttachmentsAttachmentIdDelete
     */
    readonly attachmentId: string
}

/**
 * Request parameters for apiUnitsIdAttachmentsAttachmentIdGet operation in UnitsApi.
 * @export
 * @interface UnitsApiApiUnitsIdAttachmentsAttachmentIdGetRequest
 */
export interface UnitsApiApiUnitsIdAttachmentsAttachmentIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UnitsApiApiUnitsIdAttachmentsAttachmentIdGet
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof UnitsApiApiUnitsIdAttachmentsAttachmentIdGet
     */
    readonly attachmentId: string
}

/**
 * Request parameters for apiUnitsIdAttachmentsGet operation in UnitsApi.
 * @export
 * @interface UnitsApiApiUnitsIdAttachmentsGetRequest
 */
export interface UnitsApiApiUnitsIdAttachmentsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UnitsApiApiUnitsIdAttachmentsGet
     */
    readonly id: number
}

/**
 * Request parameters for apiUnitsIdAttachmentsPost operation in UnitsApi.
 * @export
 * @interface UnitsApiApiUnitsIdAttachmentsPostRequest
 */
export interface UnitsApiApiUnitsIdAttachmentsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof UnitsApiApiUnitsIdAttachmentsPost
     */
    readonly id: number

    /**
     * 
     * @type {number}
     * @memberof UnitsApiApiUnitsIdAttachmentsPost
     */
    readonly unitId?: number

    /**
     * 
     * @type {File}
     * @memberof UnitsApiApiUnitsIdAttachmentsPost
     */
    readonly file?: File
}

/**
 * Request parameters for apiUnitsIdDealsGet operation in UnitsApi.
 * @export
 * @interface UnitsApiApiUnitsIdDealsGetRequest
 */
export interface UnitsApiApiUnitsIdDealsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UnitsApiApiUnitsIdDealsGet
     */
    readonly id: number
}

/**
 * Request parameters for apiUnitsIdDelete operation in UnitsApi.
 * @export
 * @interface UnitsApiApiUnitsIdDeleteRequest
 */
export interface UnitsApiApiUnitsIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof UnitsApiApiUnitsIdDelete
     */
    readonly id: number
}

/**
 * Request parameters for apiUnitsIdFloorsGet operation in UnitsApi.
 * @export
 * @interface UnitsApiApiUnitsIdFloorsGetRequest
 */
export interface UnitsApiApiUnitsIdFloorsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UnitsApiApiUnitsIdFloorsGet
     */
    readonly id: number
}

/**
 * Request parameters for apiUnitsIdGet operation in UnitsApi.
 * @export
 * @interface UnitsApiApiUnitsIdGetRequest
 */
export interface UnitsApiApiUnitsIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UnitsApiApiUnitsIdGet
     */
    readonly id: number
}

/**
 * Request parameters for apiUnitsIdPut operation in UnitsApi.
 * @export
 * @interface UnitsApiApiUnitsIdPutRequest
 */
export interface UnitsApiApiUnitsIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof UnitsApiApiUnitsIdPut
     */
    readonly id: number

    /**
     * 
     * @type {UpdateUnitCommand}
     * @memberof UnitsApiApiUnitsIdPut
     */
    readonly updateUnitCommand?: UpdateUnitCommand
}

/**
 * Request parameters for apiUnitsIdStatisticsGet operation in UnitsApi.
 * @export
 * @interface UnitsApiApiUnitsIdStatisticsGetRequest
 */
export interface UnitsApiApiUnitsIdStatisticsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UnitsApiApiUnitsIdStatisticsGet
     */
    readonly id: number
}

/**
 * Request parameters for apiUnitsIdStockPut operation in UnitsApi.
 * @export
 * @interface UnitsApiApiUnitsIdStockPutRequest
 */
export interface UnitsApiApiUnitsIdStockPutRequest {
    /**
     * 
     * @type {number}
     * @memberof UnitsApiApiUnitsIdStockPut
     */
    readonly id: number

    /**
     * 
     * @type {UpdateUnitStockCommand}
     * @memberof UnitsApiApiUnitsIdStockPut
     */
    readonly updateUnitStockCommand?: UpdateUnitStockCommand
}

/**
 * Request parameters for apiUnitsPost operation in UnitsApi.
 * @export
 * @interface UnitsApiApiUnitsPostRequest
 */
export interface UnitsApiApiUnitsPostRequest {
    /**
     * 
     * @type {CreateUnitCommand}
     * @memberof UnitsApiApiUnitsPost
     */
    readonly createUnitCommand?: CreateUnitCommand
}

/**
 * UnitsApi - object-oriented interface
 * @export
 * @class UnitsApi
 * @extends {BaseAPI}
 */
export class UnitsApi extends BaseAPI {
    /**
     * 
     * @param {UnitsApiApiUnitsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitsApi
     */
    public apiUnitsGet(requestParameters: UnitsApiApiUnitsGetRequest = {}, options?: AxiosRequestConfig) {
        return UnitsApiFp(this.configuration).apiUnitsGet(requestParameters.pageNumber, requestParameters.pageSize, requestParameters.categoryId, requestParameters.projectId, requestParameters.searchTerm, requestParameters.isActive, requestParameters.hasStock, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitsApiApiUnitsIdAssignFloorPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitsApi
     */
    public apiUnitsIdAssignFloorPost(requestParameters: UnitsApiApiUnitsIdAssignFloorPostRequest, options?: AxiosRequestConfig) {
        return UnitsApiFp(this.configuration).apiUnitsIdAssignFloorPost(requestParameters.id, requestParameters.assignUnitToFloorCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitsApiApiUnitsIdAttachmentsAttachmentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitsApi
     */
    public apiUnitsIdAttachmentsAttachmentIdDelete(requestParameters: UnitsApiApiUnitsIdAttachmentsAttachmentIdDeleteRequest, options?: AxiosRequestConfig) {
        return UnitsApiFp(this.configuration).apiUnitsIdAttachmentsAttachmentIdDelete(requestParameters.id, requestParameters.attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitsApiApiUnitsIdAttachmentsAttachmentIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitsApi
     */
    public apiUnitsIdAttachmentsAttachmentIdGet(requestParameters: UnitsApiApiUnitsIdAttachmentsAttachmentIdGetRequest, options?: AxiosRequestConfig) {
        return UnitsApiFp(this.configuration).apiUnitsIdAttachmentsAttachmentIdGet(requestParameters.id, requestParameters.attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitsApiApiUnitsIdAttachmentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitsApi
     */
    public apiUnitsIdAttachmentsGet(requestParameters: UnitsApiApiUnitsIdAttachmentsGetRequest, options?: AxiosRequestConfig) {
        return UnitsApiFp(this.configuration).apiUnitsIdAttachmentsGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitsApiApiUnitsIdAttachmentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitsApi
     */
    public apiUnitsIdAttachmentsPost(requestParameters: UnitsApiApiUnitsIdAttachmentsPostRequest, options?: AxiosRequestConfig) {
        return UnitsApiFp(this.configuration).apiUnitsIdAttachmentsPost(requestParameters.id, requestParameters.unitId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitsApiApiUnitsIdDealsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitsApi
     */
    public apiUnitsIdDealsGet(requestParameters: UnitsApiApiUnitsIdDealsGetRequest, options?: AxiosRequestConfig) {
        return UnitsApiFp(this.configuration).apiUnitsIdDealsGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitsApiApiUnitsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitsApi
     */
    public apiUnitsIdDelete(requestParameters: UnitsApiApiUnitsIdDeleteRequest, options?: AxiosRequestConfig) {
        return UnitsApiFp(this.configuration).apiUnitsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitsApiApiUnitsIdFloorsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitsApi
     */
    public apiUnitsIdFloorsGet(requestParameters: UnitsApiApiUnitsIdFloorsGetRequest, options?: AxiosRequestConfig) {
        return UnitsApiFp(this.configuration).apiUnitsIdFloorsGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitsApiApiUnitsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitsApi
     */
    public apiUnitsIdGet(requestParameters: UnitsApiApiUnitsIdGetRequest, options?: AxiosRequestConfig) {
        return UnitsApiFp(this.configuration).apiUnitsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitsApiApiUnitsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitsApi
     */
    public apiUnitsIdPut(requestParameters: UnitsApiApiUnitsIdPutRequest, options?: AxiosRequestConfig) {
        return UnitsApiFp(this.configuration).apiUnitsIdPut(requestParameters.id, requestParameters.updateUnitCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitsApiApiUnitsIdStatisticsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitsApi
     */
    public apiUnitsIdStatisticsGet(requestParameters: UnitsApiApiUnitsIdStatisticsGetRequest, options?: AxiosRequestConfig) {
        return UnitsApiFp(this.configuration).apiUnitsIdStatisticsGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitsApiApiUnitsIdStockPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitsApi
     */
    public apiUnitsIdStockPut(requestParameters: UnitsApiApiUnitsIdStockPutRequest, options?: AxiosRequestConfig) {
        return UnitsApiFp(this.configuration).apiUnitsIdStockPut(requestParameters.id, requestParameters.updateUnitStockCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitsApiApiUnitsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitsApi
     */
    public apiUnitsPost(requestParameters: UnitsApiApiUnitsPostRequest = {}, options?: AxiosRequestConfig) {
        return UnitsApiFp(this.configuration).apiUnitsPost(requestParameters.createUnitCommand, options).then((request) => request(this.axios, this.basePath));
    }
}
